module.exports = __webpack_public_path__ + "dc14e1493146d10ad706fd35497874c7.wav";